import type { LandingPageImageFit } from '@provision/landing-page-utils';

// Frame shapes in the editorial layout, shared with the editor so its crop outline matches.
// `background` is a full-width band, so its editor outline is a wide strip.
export const MEDIA_FRAME_ASPECT_RATIOS = {
  hero: 16 / 10.4,
  content: 16 / 11,
  background: 16 / 6,
} as const;

export type MediaFrame = keyof typeof MEDIA_FRAME_ASPECT_RATIOS;

// The focus only means something for a `cover` crop; the editor hides it otherwise, so a
// leftover value must not shift a fitted or stretched image.
export function imageFitSx(fit: LandingPageImageFit, focusX: number, focusY: number) {
  return {
    objectFit: fit,
    objectPosition: fit === 'cover' ? `${focusX}% ${focusY}%` : 'center',
  };
}
